import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { from, Observable, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { AuthService } from '../../services/auth/auth.service';

export const authGuard: CanActivateFn = (): Observable<boolean> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.firebaseUser$.pipe(
    take(1),
    switchMap((firebaseUser) => {
      if (firebaseUser) {
        return from(firebaseUser.getIdTokenResult()).pipe(
          map((token) => {
            console.log(
              '%c * Route uses auth guard * ',
              'background: black; color: white',
            );

            if (
              !firebaseUser.emailVerified ||
              token.claims.dealerManagement !== true
            ) {
              console.log(
                '%c > User prohibited! ',
                'background: red; color: white',
              );

              console.log('Signing out user and clearing local storage');
              authService.signOut();

              return false;
            }
            console.log('%c User allowed ', 'background: green; color: white');
            return true;
          }),
        );
      } else {
        router.navigate(['/sign-in']);
        return of(false);
      }
    }),
  );
};
